module.exports = __webpack_public_path__ + "static/media/39.b09efccb.JPG";